module.exports = __webpack_public_path__ + "6658127122a0582338729ef598c852fa.svg";